var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4134 14.8285L10.585 17.657C9.41824 18.8237 7.50905 18.8237 6.34233 17.657C5.1756 16.4902 5.1756 14.5811 6.34233 13.4143L9.17075 10.5859L7.75654 9.17168L4.92811 12.0001C2.9765 13.9517 2.9765 17.1196 4.92811 19.0712C6.87973 21.0228 10.0476 21.0228 11.9992 19.0712L14.8276 16.2428L13.4134 14.8285ZM11.9992 4.92904L9.17075 7.75747L10.585 9.17168L13.4134 6.34326C14.5801 5.17653 16.4893 5.17653 17.656 6.34326C18.8228 7.50998 18.8228 9.41917 17.656 10.5859L14.8276 13.4143L16.2418 14.8285L19.0702 12.0001C21.0219 10.0485 21.0219 6.88066 19.0702 4.92904C17.1186 2.97743 13.9508 2.97743 11.9992 4.92904ZM14.1205 8.46458L8.46365 14.1214L9.87786 15.5356L15.5347 9.87879L14.1205 8.46458Z",
    fill: "#909c9d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6d950503381c7e83f774faf94891369f.svg";
export { ForwardRef as ReactComponent };